import { supabase } from './supabase';

const USER_KEY = 'wooki_user';

export const saveUser = (user) => {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (e) {}
};

export const getUser = () => {
  try {
    const data = localStorage.getItem(USER_KEY);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
};

export const logout = () => {
  try {
    localStorage.removeItem(USER_KEY);
  } catch (e) {}
};

export const refreshUser = async () => {
  try {
    const user = getUser();
    if (!user?.id) return null;
    const { data } = await supabase
      .from('users')
      .select('*')
      .eq('id', user.id)
      .single();
    if (data) {
      saveUser(data);
      return data;
    }
    return user;
  } catch (e) {
    return getUser();
  }
};

export const loginOrRegister = async ({ prenom, telephone, enfants }) => {
  try {
    const { data: existing } = await supabase
      .from('users')
      .select('*')
      .eq('telephone', telephone)
      .single();

    if (existing) {
      saveUser(existing);
      return { user: existing, isNew: false };
    }

    const { data: newUser, error: userError } = await supabase
      .from('users')
      .insert({ prenom, telephone })
      .select()
      .single();

    if (userError) throw userError;

    if (enfants && enfants.length > 0) {
      const enfantsFiltres = enfants.filter(e => e.prenom && e.age);
      if (enfantsFiltres.length > 0) {
        await supabase.from('enfants').insert(
          enfantsFiltres.map(e => ({ user_id: newUser.id, prenom: e.prenom, age: parseInt(e.age) }))
        );
      }
    }

    saveUser(newUser);
    return { user: newUser, isNew: true };

  } catch (err) {
    console.error('Auth error:', err);
    return { user: null, error: err };
  }
};